import React from 'react';
import { usePrivacyLogic } from "../../Components/PrivacyPolicyLogic/PrivacyPolicyLogic";
import { getBrandName } from "../../Components/getBrandName";
const PrivacyPolicy = () => {
  const { sections, generateContent } = usePrivacyLogic();
  const { effectiveDate,website} = getBrandName();

  return (
    <div className="privacy-policy-page">
      <div className="privacy-policy-heading text-center">
        <h2 className='hero-heading text-white'>Privacy Policy</h2>
        <p className="text-muted" style={{fontSize:"1.5rem"}}>Effective Date: <strong>{effectiveDate}</strong></p>
      </div>

      <div className="privacy-container">
        <div className="py-5">
          <div className="row">
            <div className="col-12">
        <p className='text-muted'>
          {/* At {brandName}, your privacy is our priority. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you interact with our website [insert website URL], or use any of our services, or platforms related to e-commerce data and sales analytics. */}
          At Gapalyze, your privacy and data security are our highest priorities. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you interact with our website <a className='text-break' href={{website}}>{website}</a>, use our Amazon seller analytics services, or engage with our platforms related to e-commerce data and sales analytics.
        </p>
        <p className='text-muted'>
          This policy has been specifically designed to comply with Amazon's SP-API requirements, including the Acceptable Use Policy (AUP) and Data Protection Policy (DPP), ensuring the highest standards of data protection for Amazon sellers and their business information.
        </p>
              {sections.map((section) => (
                <div key={section.id} className="mb-5">
                  <h5 className="privacy-title">{section.title}</h5>
                  <div className="text-muted">
                    {generateContent(section.id)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
